/* BackShave V2: strip the date from Reviews Lite review bylines ("Name • October 13, 2026" -> "Name") */
(function () {
  var strip = function (root) {
    (root.querySelectorAll ? root.querySelectorAll('.reviews-lite-item-author') : []).forEach(function (el) {
      if (el.dataset.v2Stripped) return;
      var t = el.textContent;
      var i = t.indexOf('•');
      if (i > 0) el.textContent = t.slice(0, i).trim();
      el.dataset.v2Stripped = '1';
    });
  };
  var run = function () { strip(document); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  new MutationObserver(function (muts) {
    muts.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) strip(n); }); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
